import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "file-label" };
const _hoisted_2 = ["disabled"];
const _hoisted_3 = { class: "button is-info" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-upload mr-3" }, null, -1);
import { ref } from "vue";
import { notifyError } from "@/core/utils";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DocumentUploadButton',
    props: {
        document: {},
        label: {}
    },
    emits: ["upload"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const uploadInProgress = ref(false);
        const emit = __emit;
        const uploadDocuments = (files) => {
            uploadInProgress.value = true;
            emit('upload', {
                file: files[0],
                onDone: () => {
                    if (files.length > 1) {
                        notifyError("Only one file may be uploaded here");
                    }
                    uploadInProgress.value = false;
                }
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("label", _hoisted_1, [
                    _createElementVNode("input", {
                        class: "file-input",
                        type: "file",
                        name: "file",
                        disabled: uploadInProgress.value,
                        multiple: false,
                        onChange: _cache[0] || (_cache[0] = ($event) => (uploadDocuments($event.target.files)))
                    }, null, 40, _hoisted_2),
                    _createElementVNode("a", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(" " + _toDisplayString(uploadInProgress.value ? 'Uploading...' : _ctx.label), 1)
                    ])
                ])
            ]));
        };
    }
});
